/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import {createGlobalStyle} from 'styled-components';

import env from 'env';

const GlobalStyles = createGlobalStyle`{
  .cross-button {
    cursor: pointer;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    position: relative;
    width: 24px;
    height: 24px;
  
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 12px;
      left: 0;
      right: 0;
      height: 2px;
      background: #6725F4;
    }
  
    &:before {
      transform: rotate(45deg);
    }
  
    &:after {
      transform: rotate(-45deg);
    }
  
    span {
      display: block;
    }
  
  }

  .card-border{
     border:1.5px solid #E3E3E3;
     border-radius:12px;
  }


.custom-scrollbar {

  overflow-y: scroll;
  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    width: 6px;
    display: block;
  }

  &::-webkit-scrollbar-track {
    background: rgba(170, 170, 170, 0.583);
    border-radius: ${(props) => props.theme.borderRadius.md || '6px'};
  }

  &::-webkit-scrollbar-thumb {
    background: #967dccbc;
    border-radius: ${(props) => props.theme.borderRadius.md || '6px'};
    opacity: 0.7;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #967dccbc;
    opacity: 1;
  }

  scrollbar-width: thin;
  scrollbar-color: #967dccbc rgba(170, 170, 170, 0.583);
  }

  .meta-form-control-header{
    color: #000000;
    font-size: 1.2rem !important;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    text-align: start;
  }
}`;

export default GlobalStyles;
